import { createSelector } from '@ngrx/store';
import { AppState } from '../app.reducer';

export const selectDeviceState = (state: AppState) =>
  state.invitations;


export const selectInvitationsList = createSelector(
  selectDeviceState,
  (state) => state.invitationsList
);
export const selectInvitationsSharing = createSelector(
  selectDeviceState,
  (state) => state.sharing
);
export const selectInvitationsShared = createSelector(
  selectDeviceState,
  (state) => state.shared
);